import { formatUSD } from '../../helpers';
import AnalyticsSmallCard from './AnalyticsSmallCard';
// import useAnalytics from '../../hooks/analytics/useAnalytics';
import useMockAnalytics from '../../hooks/analytics/useMockAnalytics';

const ShortPositions = () => {
    const { analytics, isLoading, defaultData } = useMockAnalytics();

    return (
        <AnalyticsSmallCard
            title='Short Positions'
            percentageDifference={
                analytics ? analytics.shortPositions.dailyDiffPercentage.toString() : '0'
            }
            amount={formatUSD(analytics?.shortPositions.currentValue.toString() || '0', {
                maxDecimals: 0,
            })}
            data={analytics?.shortPositions.historicalData ?? defaultData}
            isLoading={isLoading}
        />
    );
};

export default ShortPositions;
